import React from 'react';
import type { ParticipantMetadata } from '@/types';
import {
  FaApple,
  FaAndroid,
  FaWindows,
  FaLinux,
  FaChrome,
  FaFirefox,
  FaSafari,
  FaEdge,
  FaOpera,
  FaDesktop,
  FaMobileAlt,
} from 'react-icons/fa';
import { CyberKoalaCallsIcon } from '@/components/icons/cyberkoala-calls-icon.tsx';

const UserAgentInfo = ({
  ip,
  id,
  role,
  avatar,
  deviceType,
  deviceModel,
  deviceVendor,
  engineName,
  engineVersion,
  osName,
  osVersion,
  browserName,
  browserVersion,
  arch,
}: ParticipantMetadata) => {
  const getOSIcon = (os: string) => {
    switch (os.toLowerCase()) {
      case 'android':
        return <FaAndroid />;
      case 'ios':
        return <FaApple />;
      case 'windows':
        return <FaWindows />;
      case 'mac':
        return <FaApple />;
      case 'linux':
        return <FaLinux />;
      default:
        return null;
    }
  };

  const getBrowserIcon = (browser: string) => {
    const lower = browser.toLowerCase();
    if (lower.includes('pardus')) {
      return <CyberKoalaCallsIcon width={18} height={18} />;
    }

    switch (lower) {
      case 'chrome':
        return <FaChrome />;
      case 'firefox':
        return <FaFirefox />;
      case 'safari':
        return <FaSafari />;
      case 'edge':
        return <FaEdge />;
      case 'opera':
        return <FaOpera />;
      default:
        return null;
    }
  };

  const getDeviceTypeIcon = (deviceType: string) => {
    if (deviceType === 'mobile') {
      return <FaMobileAlt />;
    } else if (deviceType === 'desktop' || deviceType === 'unknown') {
      return <FaDesktop />;
    }
    return null;
  };

  return (
    <div
      id="metadata"
      className="flex flex-row gap-1 rounded-sm p-1 text-foreground "
    >
      {deviceType && getDeviceTypeIcon(deviceType)}
      {osName && getOSIcon(osName)}
      {browserName && getBrowserIcon(browserName)}
    </div>
  );
};

export default UserAgentInfo;
